import I18n from "../locales";

export function FinalPage({ page }) {
  const i18n = new I18n();
  const variant = page?.settings?.variant ?? "a";

  return (
    <main className="final survey-page">
      <div className="final__intro survey-page__form">
        <h1 className="final__title">{i18n.t("thanks.title")}</h1>
        <p className="final__description">{i18n.t("thanks.description")}</p>
        <div className="final__actions">
          <a
            href={i18n.t(["thanks", "redirect_to_url", variant]) || "/"}
            className="final__link"
          >
            {i18n.t("thanks.redirect_to")}
          </a>
        </div>
      </div>
    </main>
  );
}
